import { Injectable, OnDestroy } from "@angular/core";
import { AppContainerOptions, AppContainerService } from "@mydocma/app-container";
import { AuthService, JwtAuthService } from "@mydocma/auth";
import { Customer, CustomerService } from "@mydocma/customer";
import { Project, ProjectService } from "@mydocma/project";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import { BehaviorSubject } from "rxjs";

@UntilDestroy()
@Injectable()
export class BpViewService implements OnDestroy{
    private currentCustomerSubject = new BehaviorSubject<Customer>(null);
    public currentCustomer$ = this.currentCustomerSubject.asObservable();

    private currenterProjectSubject = new BehaviorSubject<Project>(null);
    public currentProject$ = this.currenterProjectSubject.asObservable();

    private appContainerOptions: AppContainerOptions;

    constructor(
        private readonly customerService: CustomerService,
        private readonly projectService: ProjectService,
        private readonly appContainerService: AppContainerService,
        private readonly authService: AuthService
      ) {

     const jwtAuthService= this.authService as any  as JwtAuthService;
      jwtAuthService.getAccessToken()

      this.customerService.currentCustomer
        .pipe(untilDestroyed(this))
        .subscribe(p => {
          this.currentCustomerSubject.next(p);
        });

        this.projectService.currentProject
        .pipe(untilDestroyed(this))
        .subscribe(p => {
            this.currenterProjectSubject.next(p);
        });
      }




      ngOnDestroy(): void {
    }

    public closeFilter() {
        this.appContainerService.closeContentSideNav();
    }

    register(appContainer: AppContainerOptions, buttons: any[] = []) {
        this.appContainerOptions = appContainer;
        appContainer.header.customerSelection = true;
        appContainer.header.projectSelection  = true;
        appContainer.rightDrawer.visibleRightDrawerContentId = null;
        appContainer.sideNavBar.classes = ['my-bp-side-nav'];
    }

    unregister(appContainer: AppContainerOptions) {
        this.appContainerOptions = null;
    }

    registerView(component) {
        if (this.appContainerService) {
            this.appContainerService.registerFrameComponent(component);
        }
    }

    unregisterView(component) {
        if (this.appContainerService) {
            this.appContainerService.unregisterFrameComponent(component);
        }
    }

}
